<template lang="pug">
    v-layout#layout-login
        v-flex(xs12='' sm5='' offset-sm4='')
            v-card.card-login.pa-5
                v-card-title(primary-title='')
                    div.flex.s12
                        h3.headline.mb-0 Reestablecer Contraseña
                        div
                            v-flex(xs12='')
                                v-form.pt-3
                                    p Se le enviará un email a su cuenta para que pueda restablecer su contraseña
                                    v-text-field.mb-3(v-model='email' label='Email' @input="$v.email.$touch()" 
                                                      @blur="$v.email.$touch()" :error-messages="emailError" required=''
                                                      :color="colors.primary")
                                    v-btn.ml-0(type="button" color='success' v-on:click="sendEmailPassword") Enviar Correo 
                                    router-link.pb-3(tag='span' to='/login')
                                        a Iniciar Sesión
</template>

<script>
    import { mapActions } from 'vuex'
    import colors from '@/mixins/Colors'
    import { validationMixin } from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'

    export default {
        name: 'email',
        data: () => {
            return {
                email: '',
                bRejectEmailPassByServer: false,
            }
        },
        mixins: [validationMixin],
        validations: {
            email: {
                required, 
                email,
                bCorrectEmailPassByServer (value) {
                    if(this.bRejectEmailPassByServer) return false

                    return true;
                }, 
            }
        },
        computed: {
            emailError () {
                    const errors = []
                    if (!this.$v.email.$dirty) return errors
                    !this.$v.email.required && errors.push('El Email es obligatorio')
                    !this.$v.email.email && errors.push('Email incorrecto')
                    !this.$v.email.bCorrectEmailPassByServer && errors.push('Email incorrecto')

                    this.bRejectEmailPassByServer = false // if reject by server, show error message only 1 time

                    return errors
            },
        },
        methods: {
            ...mapActions('AuthModule',{
                sendEmailPasswordRequestAction:'sendEmailPasswordRequestAction'
            }),
            ...mapActions('SnackbarModalModule', {
                initSnackbar: 'initSnackbar',
                resetSnackbarState: 'resetSnackbarState',
            }),
            sendEmailPassword: function () {
                this.$v.$touch()
                if( !this.$v.$error )
                {
                    const { email, password, remember_me} = this
                    this.sendEmailPasswordRequestAction({ email, password, remember_me })
                    .then((response) => {
                        let snackInfo = null
                        if(response.data.status == 'success')
                            snackInfo = this.fillSnack('success','Éxito', 'El email fue enviado exitosamente', false, 3000)
                        else
                            snackInfo = this.fillSnack('error','Error', 'No se ha podido enviar el email', false, 3000)
                        this.initSnackbar(snackInfo)
                    })
                    .catch(err => {
                        let snackInfo = this.fillSnack('error','Error', 'No se ha podido enviar el email', false, 3000)
                        this.initSnackbar(snackInfo)

                        // Show error below input email
                        this.bRejectEmailPassByServer = true
                        this.emailError
                    }) 
				} // end if    
            }, // end function
        },
    }
</script>

<style lang="scss" scoped>
    #layout-login {
        /* Bg Image */
        background-image: url('../../assets/bg-agro.jpg');
        background-size: 100% 100%;
    }

    #layout-login::before {
        content: '';
        background-color: rgba(0, 0, 0, 0.6);
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .card-login {
        margin-top: 60px;
        background-color: rgba(255,255,255,0.85) !important;
    }

    a {
        color: darkcyan;
    }
</style>